export default "__VITE_ASSET__0c0b2b2d__"